TripService.SERVICE_NAME = 'tripService';

export default function TripService() {
    Object.assign(this, {
        isDateOfBirthRequired,
        isPassportInfoRequired,
        isMobileRequired,
    });

    function isDateOfBirthRequired(apisTsaSetting) {
        return apisTsaSetting > 0;
    }

    function isMobileRequired(apisTsaSetting) {
        return apisTsaSetting > 0;
    }

    function isPassportInfoRequired(apisTsaSetting) {
        return apisTsaSetting > 1;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-service.js